export enum ModalReportStep {
  CONFIRM = 'CONFIRM',
  DATE = 'DATE',
  ERROR = 'ERROR',
  POLICY = 'POLICY',
  SUCCESS = 'SUCCESS',
}
